import type { MembershipRole } from '../hooks/useOrganizationsApi';

/**
 * Shared role badge Tailwind classes for organization membership roles.
 * Used by OrgSwitcher and OrgManagement to ensure consistent styling.
 */
export const roleBadgeClass: Record<MembershipRole, string> = {
  owner: 'bg-amber-100 text-amber-800',
  admin: 'bg-blue-100 text-blue-800',
  member: 'bg-gray-100 text-gray-800',
};
